import React from 'react';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import moment from 'moment';
import { connect } from 'react-redux';
import i18next from 'i18next';

import { withTheme } from '@material-ui/core/styles';
import { getFormat, twoDigits, makeGraph } from 'lib/commonLib';
import { mobfeedDailyGraph } from 'lib/api/mobfeed';

import CurrentStatus from 'components/atoms/CurrentStatus';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import ContentsWrap from 'components/molecules/ContentsWrap';
import SwitchingArea from 'components/organisms/SwitchingArea';
import OutlinedButton from 'components/atoms/OutlinedButton';
import ChartButtonWrap from 'components/molecules/ChartButtonWrap';
import MultiplexChart from 'components/organisms/Chart/MultiplexChart';

const graphList = [
  {
    title: i18next.t('수집기사수'),
    data: { bar: ['NEWS_CNT'] },
    yAxisData: {
      left: { NEWS_CNT: true },
      right: {},
    },
    referenceLine: {
      NEWS_CNT: {
        type: 'average',
        label: i18next.t('수집기사수'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('PV'),
    data: { bar: ['PAGE_VIEW'] },
    yAxisData: {
      left: { PAGE_VIEW: true },
      right: {},
    },
    referenceLine: {
      PAGE_VIEW: {
        type: 'average',
        label: i18next.t('페이지뷰'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('기사 구좌노출수'),
    data: { bar: ['NEWS_GR_CNT'] },
    yAxisData: {
      left: { NEWS_GR_CNT: true },
      right: {},
    },
    referenceLine: {
      NEWS_GR_CNT: {
        type: 'average',
        label: i18next.t('기사 구좌노출수'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('기사 총노출수'),
    data: { bar: ['NEWS_TOT_EPRS_CNT'] },
    yAxisData: {
      left: { NEWS_TOT_EPRS_CNT: true },
      right: {},
    },
    referenceLine: {
      NEWS_TOT_EPRS_CNT: {
        type: 'average',
        label: i18next.t('기사 총노출수'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('기사 클릭수'),
    data: { bar: ['NEWS_CLICK_CNT'] },
    yAxisData: {
      left: { NEWS_CLICK_CNT: true },
      right: {},
    },
    referenceLine: {
      NEWS_CLICK_CNT: {
        type: 'average',
        label: i18next.t('기사 클릭수'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('기사 클릭률'),
    data: { bar: ['NEWS_CLICK_RATE'] },
    yAxisData: {
      left: { NEWS_CLICK_RATE: true, isPercent: true },
      right: {},
    },
    customizeData: {
      NEWS_CLICK_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
    referenceLine: {
      NEWS_CLICK_RATE: {
        type: 'average',
        label: i18next.t('기사 클릭율'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
  {
    title: i18next.t('유입수'),
    data: { bar: ['NEWS_INF_CNT'] },
    yAxisData: {
      left: { NEWS_INF_CNT: true },
      right: {},
    },
    referenceLine: {
      NEWS_INF_CNT: {
        type: 'average',
        label: i18next.t('유입수'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },

  {
    title: i18next.t('아웃링크수'),
    data: { bar: ['OUT_LINK_CNT'] },
    yAxisData: {
      left: { OUT_LINK_CNT: true },
      right: {},
    },
    referenceLine: {
      OUT_LINK_CNT: {
        type: 'average',
        label: i18next.t('아웃링크수'),
        visibleValue: true,
        color: '#f66172',
      },
    },
  },
];

class DailyStatisticsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      infoMessage: '',
      loading: false,
      error: false,
      noData: false,
    };
  }

  getData = () => {
    const { params, locale, t, location, handleClickSnackbar } = this.props;
    const { uri } = queryString.parse(location.search);
    const { sDate, eDate } = params;
    const format = getFormat(locale);
    this.setState({
      ...this.state,
      loading: true,
      error: false,
      noData: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });
    mobfeedDailyGraph({ ...params, uri })
      .then((response) => {
        const { data } = response.data;

        if (data.length === 0) {
          this.setState({
            ...this.state,
            loading: false,
            error: false,
            noData: true,
          });
        } else if (typeof data !== 'undefined') {
          this.setState({
            ...this.state,
            primitiveData: data,
            loading: false,
            error: false,
            noData: false,
          });

          this.handleChangeGraph(graphList[0], 0)();
        }
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
        console.log(error);
        this.setState({
          ...this.state,
          loading: false,
          error: true,
          noData: false,
        });
      });
  };

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      this.getData();
    }
  }

  /**
   * 새로고침
   */
  handleRefesh = () => {
    this.getData();
  };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    const { t, theme } = this.props;
    const dateObj = moment(originalDate, 'YYYYMMDD');
    const month = twoDigits(dateObj.month() + 1);
    const date = dateObj.date();
    const day = dateObj.day();
    let color = '';

    if (day === 0) {
      color = theme.palette.common.red;
    } else if (day === 6) {
      color = theme.palette.common.blue;
    }

    return onlyDay ? (
      `${twoDigits(date)}${t('일')}`
    ) : (
      <span style={{ color }}>{`${t(month + '월')} ${twoDigits(date)}${t(
        '일'
      )}`}</span>
    );
  };

  xAxisTick = (tickProps) => {
    const { theme } = this.props;
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const dateObj = moment(value, 'YYYYMMDD');
    const day = dateObj.day();

    const dayStr = this.makeLabel(true)(value);
    let fill = '';
    //Sunday as 0 and Saturday as 6.
    if (day === 0) {
      fill = theme.palette.common.red;
    } else if (day === 6) {
      fill = theme.palette.common.blue;
    }

    return (
      <text x={x} y={y + 10} fill={fill} textAnchor="middle">
        {dayStr}
      </text>
    );
  };

  /**
   * 버튼 클릭하여 그래프 데이터 변경
   * graphData json, index
   */
  handleChangeGraph =
    (
      {
        title,
        data,
        yAxisData,
        customizeData: customize,
        isPercent = false,
        referenceLine,
      },
      index
    ) =>
    (e) => {
      const { primitiveData } = this.state;

      if (typeof data !== 'undefined') {
        const {
          graphData,
          dataKeys,
          customizeData,
          stackId,
          keyLabel,
          referenceData,
        } = makeGraph({ data, customize, primitiveData, referenceLine });

        const result = (
          <MultiplexChart
            xAxisTick={this.xAxisTick}
            makeLabel={this.makeLabel(false)}
            data={graphData}
            dataKeys={dataKeys}
            title={title}
            customizeData={customizeData}
            keyLabel={keyLabel}
            stackId={stackId.length !== 0 ? stackId.join('$') : null}
            yAxisData={yAxisData}
            legend
            isPercent={isPercent}
            key={title}
            referenceLine={referenceData}
          />
        );

        this.setState({
          ...this.state,
          curGraphComponent: result,
          selectedIdx: index,
        });
      }
    };

  render() {
    const { handleRefesh, handleChangeGraph } = this;
    const { t } = this.props;
    const {
      infoMessage,
      curGraphComponent,
      selectedIdx,
      primitiveData,
      loading,
      error,
      noData,
    } = this.state;

    return (
      <SwitchingArea
        title={
          <>
            <InfoTitleArea
              title={t('통계그래프')}
              tooltipTitle={infoMessage}
              iconType="fainfoCircle"
              iconColor="graph"
            />
          </>
        }
        handleRefesh={handleRefesh}
      >
        {loading || noData || error ? (
          <CurrentStatus
            type={loading ? 'loading' : noData ? 'noData' : error && 'error'}
          />
        ) : (
          <>
            <ChartButtonWrap>
              {graphList.map((item, index) => {
                return (
                  <OutlinedButton
                    key={item.title}
                    onClick={handleChangeGraph(item, index)}
                    selected={selectedIdx === index}
                    disabled={!Boolean(primitiveData)}
                  >
                    {item.title}
                  </OutlinedButton>
                );
              })}
            </ChartButtonWrap>
            <ContentsWrap contentsCount={1}>{curGraphComponent}</ContentsWrap>
          </>
        )}
      </SwitchingArea>
    );
  }
}

export default withRouter(
  withTranslation()(
    connect(
      ({ locale }) => ({
        locale: locale.locale,
      }),
      null
    )(withTheme(DailyStatisticsGraph))
  )
);
